'use client';

import { PclAirportCollection } from '..';
import { Locale } from '@tuic/i18n';
import { useEffect, useState } from 'react';
import { fetchPclAirports } from '../actions/hook-proxies/pcl-airports';

type UsePclAirportsParams = {
  locale: Locale;
};

export type UsePclAirports = {
  pending: boolean;
  airports: PclAirportCollection;
};

/**
 * Use the PCL airports on the client.
 */
export const usePclAirports = ({
  locale,
}: UsePclAirportsParams): UsePclAirports => {
  let [pending, setPending] = useState(true);
  let [airports, setAirports] = useState<PclAirportCollection>({});

  useEffect(() => {
    if (!pending) {
      return;
    }

    let exec = async () => {
      setAirports(await fetchPclAirports(locale));
      setPending(false);
    };

    exec();
  }, [pending]);

  return {
    pending,
    airports,
  };
};
